<template>
  <div class="page-wrap">
    <div class="container">
      <h1 class="page-title">关于莉迪亚·萨法蒂</h1>
      <div class="feature_divider"></div>
      <div class="moto-area">
        <div>“自 1980 年推出 Repêchage 以来，我个人一直致力于提供最具创新性和最有效的护肤产品。这一承诺源于两件事：我作为美容师的背景和我个人的海洋体验。”</div>
        <div class="moto-sign">— 莉迪亚·萨尔法蒂</div>
      </div>
      <div class="video-area">
        <video controls class="video" poster="../../assets/video/LydiaSarfati.jpg">
          <source src="../../assets/video/LydiaSarfati.mp4" type="video/mp4">
          您的浏览器不支持 video 标签。
        </video>
      </div>
      <div class="feature_divider"></div>
      <div class="image-text-area">
        <div>
          <el-row :gutter="50">
            <el-col :span="12" :offset="0">
              <img class="picture" src="https://cdn.shopify.com/s/files/1/0834/3901/files/Lydia-with-lamp-web_8b66922a-b7f4-417d-9d9f-a74e11b8c864_large.jpg?12858693632476183920">
            </el-col>
            <el-col :span="12" :offset="0">
              <h3 class="sec-title">莉迪亚的人生故事</h3>
              <div class="sec-des">
                莉迪亚·萨法蒂 (Lydia Sarfati) 出生于波兰莱格尼察 (Legnica)，一座靠近捷克和德国边境的城市。作为一个年轻的女孩，她热衷于科学，尤其是化学和生物学，以及艺术，尤其是文学。这是她将创造力与对科学知识的渴望结合起来的人生激情的开始。她发现了解事物如何运作以及为何运作一直是创造和制定新产品的驱动力。
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="image-text-area">
        <div>
          <el-row :gutter="50">
            <el-col :span="12" :offset="0">
              <div class="sec-des no-title">
                在1970年夏天来到美国给了她将自己对美丽的知识和激情转化为实际行动的新机会。获得美容专业执照后，她开始了自己的第一份工作，作为一个化妆品配方师和创作者，在麦迪逊大道上调配化妆品。在纽约市一家顶级水疗中心担任首席美容师后，她冒险自立门户，在1977年开设了自己的第一家水疗中心，位于53街和麦迪逊大道。她迅速成为社交圈和名人们推崇的皮肤护理专家。1980年，她推出了四层面部护理，这是一种全新的单剂量面部护理应用概念，诞生于确保每位客户得到一致、100%有效、满意和清洁的需求。这种面部护理基于一层层新鲜收获的海藻提取物（包括我们畅销的臻蓝水漾海藻精华）和热矿物提拉面膜，被证明是将专业护肤永久改变的治疗方法。
              </div>
            </el-col>
            <el-col :span="12" :offset="0">
              <img  class="picture" src="https://cdn.shopify.com/s/files/1/0834/3901/files/vogue-bw_98c6cef4-7ab6-466c-8532-3a208449cb80_large.jpg?12113493882981816738">
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="feature_divider"></div>
      <div class="moto-area">
        <div>“我不知道业内有谁像 Lydia 这样具有前瞻性思维。30 年前，她创造了一种矿物面膜，当时还没有人这样做，而现在这就是今天所有人都在谈论的话题。Lydia 一直是我的美容偶像”</div>
        <div class="moto-sign">— Andrea Robinson，Vogue 杂志前美容编辑</div>
      </div>
      <div class="feature_divider"></div>
      <div class="image-text-area">
        <div>
          <el-row :gutter="50">
            <el-col :span="12" :offset="0">
              <img class="picture" src="https://cdn.shopify.com/s/files/1/0834/3901/files/Sarfati-Family-Repechage.jpg?v=1614980255">
            </el-col>
            <el-col :span="12" :offset="0">
              <h3 class="sec-title">家族企业</h3>
              <div class="sec-des">
                今天，Lydia 的愿景和热情与她的丈夫、联合创始人兼首席运营官 David 以及执行副总裁兼首席营销官女儿 Shiri Sarfati 分享。他们负责管理位于新泽西州锡考克斯的 50,000 平方英尺、通过 ISO 9001:2015 认证的制造、研究、开发和培训设施。Repêchage 现在是领先的基于海藻的专业护肤品牌，将天然成分与高科技研发相结合，利用专有的海藻提取方法生产出用于公司所有产品和护理的最优质海藻。
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="feature_divider"></div>
      <div class="moto-area">
        <div>“多年来，Lydia Sarfati 不仅为这个行业做出了巨大贡献，她还制定了行业标准。”</div>
        <div class="moto-sign">— Joel Gerson，博士，作者，Milady 的专业美学家标准教科书和 Milady 的美学家标准基础</div>
      </div>
      <div class="feature_divider"></div>
      <div class="image-text-area">
        <div>
          <el-row :gutter="50">
            <el-col :span="12" :offset="0">
              <h3 class="sec-title">莉迪亚对美学的热情</h3>
              <div class="sec-des">
                <div>Sarfati 是美国美学领域的先驱之一，为该行业设定了专业和商业标准。她的护肤方法被世界各地的顶级美容师实践，并在美国和全球 200 多所学校教授。Sarfati 担任世界主要国际美容疗法协会 CIDESCO 美国分会的主席。</div>
                <div>Sarfati 荣获著名的 CIDESCO Medaille du Merite，并被波兰和美国女企业家 (WE) 授予“2019 年波兰和美国年度女性”奖。2020 年，Sarfati 获得了 ROI-NJ Champions of the C-Suite Award，表彰新泽西州最有影响力的 CEO。</div>
                <div>Sarfati 还是《触手可及的成功：如何在护肤业务中取得成功》一书的作者. 旨在帮助沙龙和水疗专业人士取得职业成功。她还是教科书的特约作者，包括 Milady Standard Esthetics：Fundamentals，第十二版（Cengage Learning，2019 年）和 Oncology Esthetics®（国际肿瘤学培训，2020 年）。</div>
              </div>
            </el-col>
            <el-col :span="12" :offset="0">
              <img class="picture" src="https://cdn.shopify.com/s/files/1/0834/3901/files/Lydia-Polish-Woman-Year.jpg?v=1614981000">
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="image-text-area">
        <div>
          <el-row :gutter="50">
            <el-col :span="12" :offset="0">
              <img class="picture" src="https://cdn.shopify.com/s/files/1/0834/3901/files/Lydia_Mission.jpg?15514615939668533544">
            </el-col>
            <el-col :span="12" :offset="0">
              <h3 class="sec-title">莉迪亚的使命</h3>
              <div class="sec-des">
                <div>自从1980年推出Repêchage以来，我的个人承诺一直是提供最创新和有效的护肤产品和治疗，这些产品和治疗真正有效。这一承诺源于两个方面：一是我的美容师背景，二是我个人对海洋的体验。我希望我的客户在接受专业的面部护理后，离开时能够看起来和感觉比刚进来时更好，并在离开后的几天里持续看到效果。当我首次开设护肤诊所时的目标，而现在我继续开发和创造创新疗法和产品的原因仍然如此。亲自体验一下为什么Repêchage是您拥有美丽肤色的第二个机会，您会喜欢这种不同。</div>
                <div class="moto-sign">— 莉迪亚·萨尔法蒂</div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {

}
</script>

<style scoped>
.container{
  font-family: Montserrat, sans-serif;
  max-width: 1200px;
  margin: 0 auto;
  padding: 10px;
  padding-top: 65px;
}
.feature_divider{
  width: 100%;
  border-bottom: 1px solid;
  border-color: #cccccc;
  margin-bottom: 30px;
}
.page-title{
  font-size: 34px;
  margin-bottom: 35px;
  color: #25282a;
  font-weight: 400;
  font-style: normal;
  padding-top: 4px;
}
.picture{
  width: 100%;
}
.moto-area{
  color: #000;
  font-size: 21px;
  font-weight: 400;
  line-height: 33px;
  font-style: italic;
  margin: 1% 10% 5%;
}
.moto-sign{
  text-align: right;
  padding-top: 15px;
}
.video-area{
  margin: 50px 0 30px;
}
.video{
  width: 100%;
}
.image-text-area{
  margin: 30px 0;
}
.sec-title{
  color: #000;
  font-size: 21px;
  line-height: 33px;
  font-style: italic;
  font-weight: 500;
  margin: 1% 10%;
}
.sec-des{
  color: #505050;
  font-size: 17px;
  line-height: 30px;
  text-align: justify;
}
.no-title{
  padding-top: 60px;
}
</style>
